import React, { memo } from 'react'
import PropTypes from 'prop-types'

const LogoIcon = ({ isWhite }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 216 216'>
      <defs>
        <linearGradient
          id='laborgg-logo-icon-grad-1'
          x1='0.628'
          x2='0.517'
          y1='-0.1'
          y2='0.656'
          gradientUnits='objectBoundingBox'>
          <stop offset='0' stopColor='#248332'></stop>
          <stop offset='0.148' stopColor='#378e44' stopOpacity='0.91'></stop>
          <stop offset='0.416' stopColor='#6cac75' stopOpacity='0.671'></stop>
          <stop offset='0.769' stopColor='#c1dcc5' stopOpacity='0.282'></stop>
          <stop offset='1' stopColor='#fff' stopOpacity='0'></stop>
        </linearGradient>
        <linearGradient
          id='laborgg-logo-icon-grad-2'
          x2='1'
          y1='0.5'
          y2='0.5'
          gradientUnits='objectBoundingBox'>
          <stop offset='0' stopColor='#fff' stopOpacity='0'></stop>
          <stop offset='0.449' stopColor='#9cbac7' stopOpacity='0.494'></stop>
          <stop offset='0.82' stopColor='#53879e' stopOpacity='0.859'></stop>
          <stop offset='1' stopColor='#38748f'></stop>
        </linearGradient>
        <linearGradient
          id='laborgg-logo-icon-grad-3'
          x1='-0.07'
          x2='0.436'
          y1='0.527'
          y2='0.51'
          gradientUnits='objectBoundingBox'>
          <stop offset='0' stopColor='#ae0721'></stop>
          <stop offset='0.211' stopColor='#c44b5e' stopOpacity='0.725'></stop>
          <stop offset='0.476' stopColor='#dd98a2' stopOpacity='0.416'></stop>
          <stop offset='0.705' stopColor='#efd0d4' stopOpacity='0.188'></stop>
          <stop offset='0.888' stopColor='#faf2f3' stopOpacity='0.051'></stop>
          <stop offset='1' stopColor='#fff' stopOpacity='0'></stop>
        </linearGradient>
      </defs>
      <g data-name='Grupo 1031' transform='translate(-435 -313)'>
        <g data-name='Grupo 1029' transform='translate(301.265 115.544)'>
          <g data-name='Grupo 1025' transform='translate(297.44 271.055)'>
            <path
              className={isWhite ? 'white' : ''}
              fill='#69bb8f'
              d='M300.576 275.636c.021.048.037.091.061.134-.024-.043-.037-.086-.061-.134z'
              data-name='Trazado 137'
              transform='translate(-298.278 -271.207)'></path>
            <path
              className={isWhite ? 'white' : ''}
              fill='#69bb8f'
              d='M306.006 293.282c.091.55.193 1.1.273 1.651-.079-.556-.179-1.101-.273-1.651z'
              data-name='Trazado 138'
              transform='translate(-298.278 -271.207)'></path>
            <path
              className={isWhite ? 'white' : ''}
              fill='#69bb8f'
              d='M298.278 271.207c.027.048.054.1.08.139-.026-.046-.058-.091-.08-.139z'
              data-name='Trazado 139'
              transform='translate(-298.278 -271.207)'></path>
            <path
              className={isWhite ? 'white' : ''}
              fill='#fc9220'
              d='M307 303.422a53.117 53.117 0 00-.489-7.073c-.059-.481-.166-.941-.235-1.416a74.11 74.11 0 01.71 8.436c.006.016.014.031.014.053z'
              data-name='Trazado 140'
              transform='translate(-298.278 -271.207)'></path>
            <path
              className={isWhite ? 'white' : ''}
              fill='#fc9220'
              d='M298.358 271.346q1.194 2.115 2.218 4.29a63.435 63.435 0 00-2.218-4.29z'
              data-name='Trazado 141'
              transform='translate(-298.278 -271.207)'></path>
            <path
              className={isWhite ? 'white' : ''}
              fill='#fc9220'
              d='M300.637 275.77a67.629 67.629 0 015.369 17.512 67.827 67.827 0 00-5.369-17.512z'
              data-name='Trazado 142'
              transform='translate(-298.278 -271.207)'></path>
          </g>
          <path
            className={isWhite ? 'white' : ''}
            fill='#69bb8f'
            d='M315.772 329.671a12.178 12.178 0 00-12.143-1.5 77.4 77.4 0 003.36-24.806c-1.335-9.179-6.229-16.349-13.132-22.653.935 56.211-50.831 80.038-50.831 80.038-2.5.854-24.687 7.955-36.778.668a33.285 33.285 0 005.367 3.419c28.358 16.1 69.709 1.645 82.465-16.7 1.012-1.459 1.947-2.982 2.852-4.532a12.167 12.167 0 0021.132 3.18 12.212 12.212 0 00-2.292-17.114z'
            data-name='Trazado 143'
            transform='translate(-.838 -.345)'></path>
          <path
            id='logo-icon-grad-1'
            className={isWhite ? 'white' : ''}
            d='M315.772 329.671a12.178 12.178 0 00-12.143-1.5 77.4 77.4 0 003.36-24.806c-1.335-9.179-6.229-16.349-13.132-22.653.935 56.211-50.831 80.038-50.831 80.038-2.5.854-24.687 7.955-36.778.668a33.285 33.285 0 005.367 3.419c28.358 16.1 69.709 1.645 82.465-16.7 1.012-1.459 1.947-2.982 2.852-4.532a12.167 12.167 0 0021.132 3.18 12.212 12.212 0 00-2.292-17.114z'
            data-name='Trazado 144'
            transform='translate(-.838 -.345)'
            style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}></path>
          <g data-name='Grupo 1028' transform='translate(165.735 217.455)'>
            <path
              className={isWhite ? 'white' : ''}
              fill='#17b1cf'
              d='M243.013 360.754a2.723 2.723 0 01-.294-.123S190.4 336.9 191.928 278.975c.27-10.311 4.37-20.27 11.754-27.119a40.292 40.292 0 00-4.961 4.074c-20.449 18.76-24.568 47.834-16.7 71.994a12.243 12.243 0 107.316 15.825q1.611 2.564 3.438 4.963a58.4 58.4 0 0013.733 12.913c-.077-.069-.182-.134-.257-.2 12.077 7.275 34.224.194 36.762-.671z'
              data-name='Trazado 145'
              transform='translate(-165.735 -217.801)'></path>
            <path
              id='logo-icon-grad-2'
              className={isWhite ? 'white' : ''}
              d='M243.013 360.754a2.723 2.723 0 01-.294-.123S190.4 336.9 191.928 278.975c.27-10.311 4.37-20.27 11.754-27.119a40.292 40.292 0 00-4.961 4.074c-20.449 18.76-24.568 47.834-16.7 71.994a12.243 12.243 0 107.316 15.825q1.611 2.564 3.438 4.963a58.4 58.4 0 0013.733 12.913c-.077-.069-.182-.134-.257-.2 12.077 7.275 34.224.194 36.762-.671z'
              data-name='Trazado 146'
              transform='translate(-165.735 -217.801)'
              style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}></path>
            <g data-name='Grupo 1026' transform='translate(25.349)'>
              <path
                className={isWhite ? 'white' : ''}
                fill='#fc9220'
                d='M306.514 296.349c-1.963-16.044-9.136-30.41-20.622-40.576a60.331 60.331 0 00-35.143-16.627 12.24 12.24 0 10-17.289-1.736 11.864 11.864 0 001.742 1.75 64.214 64.214 0 00-31.713 12.9 38.344 38.344 0 00-11.561 26.915c-.016.555.005 1.09 0 1.64 5.062-5.92 11.882-10.626 20.539-14.03 8.727-3.429 18.75-6.255 30.5-6.037a73.592 73.592 0 0128.665 5.856 87.244 87.244 0 0120.494 12.747c7.845 6.694 13.447 14.3 14.882 24.271a53.117 53.117 0 00-.494-7.073z'
                data-name='Trazado 147'
                transform='translate(-191.922 -217.455)'></path>
            </g>
            <g
              data-name='Grupo 1027'
              transform='translate(25.349)'
              style={{ mixBlendMode: 'multiply', isolation: 'isolate' }}>
              <path
                id='logo-icon-grad-3'
                className={isWhite ? 'white' : ''}
                d='M306.514 296.349c-1.963-16.044-9.136-30.41-20.622-40.576a60.331 60.331 0 00-35.143-16.627 12.24 12.24 0 10-17.289-1.736 11.864 11.864 0 001.742 1.75 64.214 64.214 0 00-31.713 12.9 38.344 38.344 0 00-11.561 26.915c-.016.555.005 1.09 0 1.64 5.062-5.92 11.882-10.626 20.539-14.03 8.727-3.429 18.75-6.255 30.5-6.037a73.592 73.592 0 0128.665 5.856 87.244 87.244 0 0120.494 12.747c7.845 6.694 13.447 14.3 14.882 24.271a53.117 53.117 0 00-.494-7.073z'
                data-name='Trazado 148'
                transform='translate(-191.922 -217.455)'></path>
            </g>
          </g>
        </g>
        <circle
          cx='108'
          cy='108'
          r='108'
          fill='none'
          data-name='Elipse 8'
          transform='translate(435 313)'></circle>
      </g>
    </svg>
  )
}

LogoIcon.propTypes = {
  isWhite: PropTypes.bool,
}

export default memo(LogoIcon)
